module.exports = "favicons/favicon-16x16.png";